import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { GetOneClientAction, UpdateClientAction } from '../Redux/Actions/UsersAction';
import { TextField } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Add_Commission_Data_Action } from '../Redux/Actions/Commission_Action';
import { Notify } from '../Utility/Notify';

export const LeadReviewCommissionPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [commissionRate, setCommissionRate] = useState(0);
  const [commissionValue, setCommissionValue] = useState(0);

  //   const [developerCashbackRate, setDeveloperCashbackRate] = useState(0)
  //   const [developerCashbackValue, setDeveloperCashbackValue] = useState(0)

  const [companyCashbackRate, setCompanyCashbackRate] = useState(0);
  const [companyCashbackValue, setCompanyCashbackValue] = useState(0);

  const [salesRate, setSalesRate] = useState(0);
  const [salesValue, setSalesValue] = useState(0);

  const [marketerRate, setMarketerRate] = useState(0);
  const [marketerValue, setMarketerValue] = useState(0);

  const [teamLeaderRate, setTeamLeaderRate] = useState(0);
  const [teamLeaderValue, setTeamLeaderValue] = useState(0);

  const [managerRate, setManagerRate] = useState(0);
  const [managerValue, setManagerValue] = useState(0);

  const [vatRate, setVatRate] = useState(5);
  const [vatValue, setVatValue] = useState(0);

  const [finalBalance, setFinalBalance] = useState(0);

  const selectedLeadResponse = useSelector((state) => state.Allusers.Get_users);
  const leadData = selectedLeadResponse?.data || {};

  // console.log(leadData,"leaddata")
  useEffect(() => {
    if (id) {
      dispatch(GetOneClientAction(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    const price = parseFloat(leadData.unit_price) || 0;
    const calcFromPrice = (rate) => (price * parseFloat(rate || 0)) / 100;

    const commission = calcFromPrice(commissionRate);
    // const developerCashback = calcFromPrice(developerCashbackRate)
    const companyCashback = calcFromPrice(companyCashbackRate);

    const calcFromCommission = (rate) => (commission * parseFloat(rate || 0)) / 100;

    const sales = calcFromCommission(salesRate);
    const marketer = calcFromCommission(marketerRate);
    const teamLeader = calcFromCommission(teamLeaderRate);
    const manager = calcFromCommission(managerRate);

    const vat = (commission * vatRate) / 100;

    // const totalDeductions = commission + developerCashback + companyCashback + sales + marketer + teamLeader + manager + vat
    const netBalance = commission - companyCashback - sales - marketer - teamLeader - manager;

    setCommissionValue(commission);
    // setDeveloperCashbackValue(developerCashback)
    setCompanyCashbackValue(companyCashback);
    setSalesValue(sales);
    setMarketerValue(marketer);
    setTeamLeaderValue(teamLeader);
    setManagerValue(manager);
    setVatValue(vat);
    setFinalBalance(netBalance);
  }, [
    commissionRate,
    // developerCashbackRate,
    companyCashbackRate,
    salesRate,
    marketerRate,
    teamLeaderRate,
    managerRate,
    vatRate,
    leadData.unit_price,
  ]);

  const renderInput = (label, value, onChange) => (
    <>
      <div className="my-3">{label}</div>
      <div className="d-flex">
        <TextField label={label} type="number" value={value} onChange={onChange} className="w-75" />
        <div style={{ fontSize: '30px' }}>%</div>
      </div>
    </>
  );

  const renderResult = (label, value, color) => (
    <div className="my-4">
      <strong>{label}</strong>
      <div style={{ fontSize: '24px', color: color || 'black' }}>{value.toLocaleString()} AED</div>
      <hr />
    </div>
  );

  const [paymentDate, setPaymentDate] = useState('');
  const [Loadingadd, setloadingadd] = useState(true);

  //   confirm data

  const confirmData = async () => {
    const requiredFields = [
      { label: 'Company Commission Rate', value: commissionRate },
      { label: 'Company Cashback Rate', value: companyCashbackRate },
      { label: 'Sales Rate', value: salesRate },
      { label: 'Marketer Rate', value: marketerRate },
      { label: 'Team Leader Rate', value: teamLeaderRate },
      { label: 'Manager Rate', value: managerRate },
      { label: 'VAT Rate', value: vatRate },
      { label: 'Payment Date', value: paymentDate },
      { label: 'Company Commission', value: commissionValue },
      { label: 'Sales Commission', value: salesValue },
      { label: 'Marketer Commission', value: marketerValue },
      { label: 'Team Leader Commission', value: teamLeaderValue },
      { label: 'Manager Commission', value: managerValue },
    ];

    const emptyField = requiredFields.find(
      (field) =>
        field.value === '' || field.value === null || field.value === undefined || field.value <= 0,
    );

    if (emptyField) {
      Notify(
        'error',
        `❌ Please fill in the required field and check the value of this input: ${emptyField.label}`,
        'error',
      );
      return;
    }

    // تأكد إن فيه بيانات للعميل
    if (!leadData || !leadData.project || !leadData.project.developer || !leadData.unit_price) {
      Notify('error', '❌ Lead data is incomplete or not loaded.', 'error');
      return;
    }

    setloadingadd(true);

    try {
      await dispatch(
        Add_Commission_Data_Action({
          lead: id,
          project: leadData?.project?._id,
          developer: leadData?.project?.developer?._id,
          sales: leadData?.sales?.name,
          teamleader: leadData?.sales?.teamleader?.name,
          marketer: leadData?.chanel?.name,
          manager: leadData?.sales?.Manager?.name,
          commissionRate,
          commissionValue,
          companyCashbackRate,
          companyCashbackValue,
          salesRate,
          salesValue,
          marketerRate,
          marketerValue,
          teamLeaderRate,
          teamLeaderValue,
          managerRate,
          managerValue,
          vatRate,
          vatValue,
          finalBalance,
          paymentDate,
          unitprice: leadData.unit_price,
        }),
      );

      await dispatch(
        UpdateClientAction(id, {
          revenue: commissionValue,
          review: true,
        }),
      );

      Notify('success', '✅ Commission data submitted successfully!', 'success');

      // إعادة التوجيه بعد 1.5 ثانية
      setTimeout(() => {
        window.location.href = '#/LeadsForAccountant';
      }, 1500);
    } catch (error) {
      console.error(error);
      Notify('error', '❌ Something went wrong while submitting data.', 'error');
    } finally {
      setloadingadd(false);
    }
  };

  const resAllcommisssions = useSelector((state) => state.AllCommissions.Add_Commission);
  const AllCommissionsarray = Array.isArray(resAllcommisssions?.data)
    ? resAllcommisssions.data
    : [];

  return (
    <Container className="startpage">
      <Link to={`/LeadsForAccountant`} style={{ textDecoration: 'none', color: '#0F7687' }}>
        <span style={{ fontWeight: 'bold' }}>Home</span>
      </Link>{' '}
      <KeyboardDoubleArrowRightIcon /> <span>Confirm Lead Data </span>
      <h4>Let's Go To Calculate Commission 😍</h4>
      <div className="d-flex justify-content-between my-4">
        <div style={{ fontSize: '20px' }}>Lead Name : {leadData.name}</div>
        <div style={{ fontSize: '20px' }}>
          Unit Price : <span style={{ color: 'royalblue' }}>{leadData.unit_price}</span>
        </div>
      </div>
      <div>Developer :{leadData?.project?.developer?.name}</div>
      <div>Project : {leadData?.project?.name}</div>
      <hr />
      {renderInput('Company Commission Rate %:', commissionRate, (e) =>
        setCommissionRate(e.target.value),
      )}
      {renderResult('Total Company Commission:', commissionValue, 'green')}
      {/* {renderInput("Cashback (Developer) Rate %:", developerCashbackRate, (e) => setDeveloperCashbackRate(e.target.value))}
      {renderResult("Total Cashback (Developer):", developerCashbackValue, "blue")} */}
      {renderInput('Cashback (Company) Rate %:', companyCashbackRate, (e) =>
        setCompanyCashbackRate(e.target.value),
      )}
      {renderResult('Total Cashback (Company):', companyCashbackValue, 'purple')}
      {renderInput(
        <>
          Sales Commission Rate % (from Company Commission):{' '}
          <span style={{ fontWeight: 'bold', color: '#007bff' }}>{leadData?.sales?.name}</span>
        </>,
        salesRate,
        (e) => setSalesRate(e.target.value),
      )}{' '}
      {renderResult('Sales Commission (from total company commission):', salesValue, '#ff9800')}
      {renderInput(
        <>
          Marketer Commission Rate % (from Company Commission):{' '}
          <span style={{ fontWeight: 'bold', color: '#28a745', fontSize: '16px' }}>
            {leadData?.chanel?.name}
          </span>
        </>,
        marketerRate,
        (e) => setMarketerRate(e.target.value),
      )}{' '}
      {renderResult('Marketer Commission:', marketerValue, '#00bcd4')}
      {renderInput(
        <>
          Team Leader Commission Rate % (from Company Commission):{' '}
          <span style={{ fontWeight: 'bold', color: '#28a745', fontSize: '16px' }}>
            {leadData?.sales?.teamleader?.name}
          </span>
        </>,
        teamLeaderRate,
        (e) => setTeamLeaderRate(e.target.value),
      )}{' '}
      {renderResult('Team Leader Commission:', teamLeaderValue, '#9c27b0')}
      {renderInput(
        <>
          Manager Commission Rate % (from Company Commission):{' '}
          <span style={{ fontWeight: 'bold', color: '#6610f2', fontSize: '16px' }}>
            {leadData?.sales?.Manager?.name}
          </span>
        </>,
        managerRate,
        (e) => setManagerRate(e.target.value),
      )}{' '}
      {renderResult('Manager Commission:', managerValue, '#607d8b')}
      {renderInput('VAT %:', vatRate, (e) => setVatRate(e.target.value))}
      {renderResult('VAT Value:', vatValue, '#f44336')}
      {/* Date of Payment */}
      <div className="mb-3">
        <label htmlFor="paymentDate" className="form-label">
          Date of Payment
        </label>
        <input
          type="date"
          className="form-control"
          id="paymentDate"
          value={paymentDate}
          onChange={(e) => setPaymentDate(e.target.value)}
        />
      </div>
      <div className="my-5">
        <h5>💰 Final Balance:</h5>
        <div style={{ fontSize: '28px', color: 'darkgreen' }}>
          {finalBalance.toLocaleString()} AED
        </div>

        <div>
          {/* Confirm Button */}
          <div className="btn btn-primary w-100 my-4" onClick={confirmData}>
            Confirm <CheckIcon />
          </div>
        </div>
      </div>
      <div style={{ marginTop: '100px' }}></div>
    </Container>
  );
};
